__turbopack_context__.v({
  "card": "ArticleCard-module-scss-module__7B89Wa__card",
  "description": "ArticleCard-module-scss-module__7B89Wa__description",
  "image": "ArticleCard-module-scss-module__7B89Wa__image",
  "title": "ArticleCard-module-scss-module__7B89Wa__title",
});
